import { curry, type PlatformEvent } from 'lib/util'

/**
 * Returns the y-axis unit labels of the acoustic spectrum chart.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 * @returns the label's text
 */
const formatAcousticSpectrumYLabel = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent<{ label: number }>,
): string => {
  const label = event.detail.label as number
  return `10^${label.toFixed(1)}`
}

export default curry(formatAcousticSpectrumYLabel)
